var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduleIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0192 3.8777L19.489 3.29308L19.0192 3.8777C19.259 4.07039 19.4771 4.28854 19.6698 4.52831C20.0967 5.05955 20.3444 5.74963 20.4742 6.86316C20.6057 7.99278 20.6069 9.4588 20.6069 11.5001C20.6069 13.5414 20.6057 15.0074 20.4742 16.137C20.3444 17.2505 20.0967 17.9406 19.6698 18.4718C19.4771 18.7116 19.259 18.9298 19.0192 19.1224C18.4879 19.5494 17.7979 19.7971 16.6843 19.9268C15.5547 20.0584 14.0887 20.0596 12.0474 20.0596H10.9522C8.91089 20.0596 7.44488 20.0584 6.31526 19.9268C5.20173 19.7971 4.51165 19.5494 3.98041 19.1224C3.74064 18.9298 3.52249 18.7116 3.3298 18.4718L2.74518 18.9416L3.3298 18.4718C2.90289 17.9406 2.65514 17.2505 2.52543 16.137C2.39384 15.0074 2.39265 13.5414 2.39265 11.5001C2.39265 9.4588 2.39384 7.99278 2.52543 6.86316C2.65514 5.74963 2.90289 5.05955 3.3298 4.52831C3.52249 4.28854 3.74064 4.07039 3.98041 3.8777C4.51165 3.45079 5.20173 3.20304 6.31526 3.07333C7.44488 2.94174 8.9109 2.94055 10.9522 2.94055H12.0474C14.0887 2.94055 15.5547 2.94174 16.6843 3.07333C17.7979 3.20304 18.4879 3.45079 19.0192 3.8777Z",
    stroke: "#0E204D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64265 7.66663H21.3569",
    stroke: "#0E204D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12H14",
    stroke: "#0E204D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H10",
    stroke: "#0E204D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57114 1.09534V3.57788M16.4283 1.09534V3.57788",
    stroke: "#0E204D",
    strokeWidth: 1.725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIconBlue);
export default __webpack_public_path__ + "static/media/scheduleIconBlue.864a96be10091b5590a8c1e5036a5273.svg";
export { ForwardRef as ReactComponent };